import React from 'react';
import { FaTwitch, FaYoutube, FaTwitter, FaInstagram, FaTiktok } from 'react-icons/fa';
import SectionHeader from '../ui/SectionHeader';
import Reveal from '../ui/Reveal';
import Button from '../ui/Button';
import TiltCard from '../ui/TiltCard';
import talents from '../../data/talents.json';
import './Creators.css';

const SOCIAL_ICONS = {
  twitch: FaTwitch,
  youtube: FaYoutube,
  youtube2: FaYoutube,
  twitter: FaTwitter,
  instagram: FaInstagram,
  tiktok: FaTiktok,
};

const socialLabel = (platform) =>
  platform === 'youtube2' ? 'Second YouTube channel' : platform;

const Creators = () => {
  const featured = talents.filter((t) => t.featured).slice(0, 4);

  return (
    <section className="creators tra-section" id="creators">
      <div className="tra-container">
        <div className="creators__head">
          <SectionHeader
            eyebrow="Our Roster"
            title="The creators who define us"
            subtitle="We exclusively represent a hand-picked roster of gaming's most engaging voices."
          />
          <Reveal className="creators__head-cta">
            <Button to="/talent-roster" variant="secondary" arrow>
              View Full Roster
            </Button>
          </Reveal>
        </div>

        <div className="creators__grid">
          {featured.map((t, i) => (
            <TiltCard className="creator-card" key={t.id} delay={i * 0.08}>
              <div className="creator-card__image">
                <img src={process.env.PUBLIC_URL + t.image} alt={t.name} loading="lazy" />
                <div className="creator-card__overlay" />
                <span className="creator-card__reach">{t.reach} reach</span>
              </div>
              <div className="creator-card__info">
                <h3 className="creator-card__name">{t.name}</h3>
                <span className="creator-card__category">{t.category}</span>
                <div className="creator-card__socials">
                  {Object.entries(t.socials).map(([platform, url]) => {
                    const Icon = SOCIAL_ICONS[platform];
                    if (!Icon) return null;
                    return (
                      <a key={platform} href={url} target="_blank" rel="noopener noreferrer" aria-label={socialLabel(platform)}>
                        <Icon />
                      </a>
                    );
                  })}
                </div>
              </div>
            </TiltCard>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Creators;
